"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "small-image": "AssetIcon__small-image__2JQsc",
  "smallImage": "AssetIcon__small-image__2JQsc"
}; 
require('./AssetIcon.css');
var AssetIcon = function AssetIcon(_ref) {
  var _ref$isEditing = _ref.isEditing,
    isEditing = _ref$isEditing === void 0 ? false : _ref$isEditing,
    _ref$isCertified = _ref.isCertified,
    isCertified = _ref$isCertified === void 0 ? false : _ref$isCertified,
    size = _ref.size,
    alt = _ref.alt,
    type = _ref.type,
    initialIcon = _ref.icon,
    onEditIcon = _ref.onEditIcon;
  var _useState = (0, _react.useState)(initialIcon),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    icon = _useState2[0],
    setIcon = _useState2[1];
  var onSaveIcon = function onSaveIcon(iconFile) {
    var reader = new FileReader();
    reader.readAsDataURL(iconFile);
    reader.onloadend = function () {
      var base64data = reader.result;
      setIcon(base64data);
      onEditIcon(base64data, iconFile.type);
    };
  };
  var onDeleteIcon = function onDeleteIcon() {
    setIcon(null);
    onEditIcon(null);
  };
  (0, _react.useEffect)(function () {
    setIcon(initialIcon);
  }, [isEditing, initialIcon]);
  (0, _react.useEffect)(function () {
    if (isEditing) {
      var editIcon = document.querySelector('[data-test-id="edit-asset-icon"]');
      var deleteIcon = document.querySelector('[data-test-id="asset-icon-delete"]');
      editIcon === null || editIcon === void 0 || editIcon.focus();
      deleteIcon === null || deleteIcon === void 0 || deleteIcon.focus();
    }
  }, [isEditing]);
  return size === 'sm' ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "image-container",
    className: styles.smallImage
  }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetImage, {
    type: type,
    icon: icon,
    size: size,
    alt: alt,
    isEditable: isEditing,
    onDeleteIcon: onDeleteIcon,
    onSaveIcon: onSaveIcon,
    isCertified: isCertified,
    ariaHidden: true
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_exchangeUiComponents.AssetImage, {
    type: type,
    icon: icon,
    size: size,
    alt: alt,
    isEditable: isEditing,
    onDeleteIcon: onDeleteIcon,
    onSaveIcon: onSaveIcon,
    isCertified: isCertified,
    ariaHidden: true
  }));
};
var _default = exports.default = AssetIcon;
//# sourceMappingURL=AssetIcon.js.map